// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.110.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.110.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginPage {
  width: 360px;
  margin: auto;
  padding-top: 25%;
}

.loginHeader {
  padding-bottom: 32px;
}

.logo_login {
  width: 270px;
}

.login-form {
  position: relative;
  z-index: 1;
  max-width: 360px;
  margin: 0 auto 100px;
  padding: 45px;
  text-align: center;
}

.usernameInput {
  background: #f2f2f2;
  width: 100%;
  border: 0;
  border-radius: 5px 5px 0 0;
  padding: 15px;
  box-sizing: border-box;
  font-size: 14px;
}

.passwordInput {
  background: #f2f2f2;
  width: 100%;
  border: 0;
  border-radius: 0 0 5px 5px;
  margin: 0 0 15px;
  padding: 15px;
  box-sizing: border-box;
  font-size: 14px;
}

.login-form button {
  background: var(--primaryColor);
  width: 100%;
  border: 1px solid var(--primaryColor);
  border-radius: 5px;
  padding: 15px;
  color: #ffffff;
  font-size: 14px;
}

.login-options {
  margin-bottom: 0;
}

.login-forgot {
  float: right;
}

.footer {
  margin-top: 50%;
  font-size: 0.85em;
}
`, "",{"version":3,"sources":["webpack://./src/login/login.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".loginPage {\n  width: 360px;\n  margin: auto;\n  padding-top: 25%;\n}\n\n.loginHeader {\n  padding-bottom: 32px;\n}\n\n.logo_login {\n  width: 270px;\n}\n\n.login-form {\n  position: relative;\n  z-index: 1;\n  max-width: 360px;\n  margin: 0 auto 100px;\n  padding: 45px;\n  text-align: center;\n}\n\n.usernameInput {\n  background: #f2f2f2;\n  width: 100%;\n  border: 0;\n  border-radius: 5px 5px 0 0;\n  padding: 15px;\n  box-sizing: border-box;\n  font-size: 14px;\n}\n\n.passwordInput {\n  background: #f2f2f2;\n  width: 100%;\n  border: 0;\n  border-radius: 0 0 5px 5px;\n  margin: 0 0 15px;\n  padding: 15px;\n  box-sizing: border-box;\n  font-size: 14px;\n}\n\n.login-form button {\n  background: var(--primaryColor);\n  width: 100%;\n  border: 1px solid var(--primaryColor);\n  border-radius: 5px;\n  padding: 15px;\n  color: #ffffff;\n  font-size: 14px;\n}\n\n.login-options {\n  margin-bottom: 0;\n}\n\n.login-forgot {\n  float: right;\n}\n\n.footer {\n  margin-top: 50%;\n  font-size: 0.85em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
